<template>
    <Modal size="small" class="modal modal--mob modal--paypal" @close="$emit('close')">

        <template #body>
            <div class="u-text-center">
                <img class="mb-" src="/img/payment_types/PAYPAL.svg" alt="">
            </div>

            <h2 class="u-text-center heading">{{ $t('payment.paypal.add_credits') }}</h2>
            <template v-if="!confirmStep">
                <p>{{ $t('payment.paypal.payment') }}</p>
                <h2 class="u-text-left mb-">{{ $t('payment.paypal.your_order') }}</h2>
                <div class="u-text-left">
                    <p class="mb--">{{ $t('payment.paypal.package', {credits: selectedPackage.credits}) }}</p>
                    <p class="mb--">{{ $t('payment.paypal.price', {price: selectedPackage.price.toFixed(2), currency: selectedPackage.currency}) }}</p>
                    <p class="mb">{{ $t('payment.paypal.vat') }}</p>
                    <button type="button" @click="confirm" class="button button--primary w-100 mb--">{{ $t('payment.paypal.order_now') }}</button>
                    <button @click="$emit('close')" type="button" class="button button--fourth w-100">{{ $t('payment.paypal.cancel') }}</button>
                </div>
            </template>
            <template v-else>
                <div class="mt">
                    <p class="u-text-center sub-heading" v-html="$t('payment.paypal.please_transfer', {price: selectedPackage.price.toFixed(2), currency: selectedPackage.currency})"></p>
                    <div class="blue-box" v-html="$t('payment.paypal.additionally')"></div>
                    <CopyLink @success="copyHandler(true)" @error="copyHandler(false)" link="maiatsacoltd@protonmail.com" class="mb" />
                    <button @click="$emit('close')" type="button" class="button button--primary w-100">{{$t('payment.paypal.close')}}</button>
                </div>
            </template>
        </template>
    </Modal>
</template>

<script>
import Modal from "@/components/generic/Modal.vue";
import CopyLink from "@/components/generic/CopyLink.vue";
import toastr from "toastr";
export default {
    name: "PayPalConfirmModal",
    components: {CopyLink, Modal },
    emits: ['close', 'confirmed'],
    props: {
        selectedPackage: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            confirmStep: false,
            working: false
        }
    },
    methods: {
        confirm() {
            this.confirmStep = true
            this.$emit('confirmed')
        },
        copyHandler(outcome) {
            outcome ?
                toastr.success(this.$i18n.t('payment.paypal.copied')) :
                toastr.error(this.$i18n.t('credits.error_processing'))
        }
    }
}
</script>

<style scoped lang="scss">

.modal--paypal {
    text-align: center;

    p {
        line-height: 1.3;
        font-size: 14px;
    }
}

</style>

<style lang="scss">
    .modal--paypal {

        .modal-container {
            padding-top: 40px!important;

            .modal-header {

                .close {
                    display: block!important;
                    top: 0!important;
                    right: 0!important;
                }
            }
        }

        .heading {
            letter-spacing: -0.9px;
            font-size: 22px;
            line-height: 26px;
            color: #000000;
            margin-top: 20px;
        }

        .sub-heading {
            font-size: 16px;
            line-height: 23px;
            color: #000000;
        }

        .blue-box {
            text-align: center;
            background-color: #BFD6FF;
            border-radius: 10px;
            padding: 14px;
            color: #000000;
            font-size: 16px;
            line-height: 23px;
            margin-bottom: 10px;
            font-family: "Open Sans", sans-serif;
        }
    }
</style>